module.exports = __webpack_public_path__ + "img/益视说明书_05.4c578d49.png";